import { TransactionList } from 'models'

/**
 * Creates array of transactions from backend response
 * @param {MappingResponse}
 * @returns {Array<TransactionList>} returns transaction array
 *  if user have not any transaction, returns an empty array
 */
export const transactionListFactory = (listData = []) => {
    if (listData.length === 0) return []

    return listData.map(
        (item) =>
            new TransactionList({
                datetime: item.datetime,
                paymentMethod: item.paymentMethod,
                isRecurring: item.isRecurring,
                externalProductId: item.externalProductId,
                productId: item.productId,
                productType: item.productType,
                productName: item.productName,
                currencyCode: item.currencyCode,
                priceFinal: item.priceFinal,
                rentalStartDate: item.rentalStartDate,
                rentalEndDate: item.rentalEndDate,
                purchaseType: item.purchaseType,
                transactionId: item.transactionId,
                transactionStatus: item.transactionStatus,
                device: item.device,
                deviceId: item.deviceId,
                userIpAddress: item.userIpAddress,
            })
    )
}
